/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

export enum TerminalPlatformsEnum {
  Airborne = 1,
  Maritime = 2,
  Ground = 3,
  Fixed = 4,
  GroundNomadic = 5,
  SpaceVehicle = 6,
}

export interface TerminalPlatformDetails {
  displayNameId: string; // id of the field text present in the locale file
  defaultDisplayName: string;
}

export const TERMINAL_PLATFORMS: { [key in TerminalPlatformsEnum]: TerminalPlatformDetails } = {
  [TerminalPlatformsEnum.Airborne]: {
    displayNameId: 'terminal.platform_type.airborne',
    defaultDisplayName: 'Airborne',
  },
  [TerminalPlatformsEnum.Maritime]: {
    displayNameId: 'terminal.platform_type.maritime',
    defaultDisplayName: 'Maritime',
  },
  [TerminalPlatformsEnum.Ground]: {
    displayNameId: 'terminal.platform_type.ground',
    defaultDisplayName: 'Ground',
  },
  [TerminalPlatformsEnum.Fixed]: {
    displayNameId: 'terminal.platform_type.fixed',
    defaultDisplayName: 'Fixed',
  },
  [TerminalPlatformsEnum.GroundNomadic]: {
    displayNameId: 'terminal.platform_type.GroundNomadic',
    defaultDisplayName: 'Ground Nomadic',
  },
  [TerminalPlatformsEnum.SpaceVehicle]: {
    displayNameId: 'terminal.platform_type.SpaceVehicle',
    defaultDisplayName: 'Space Vehicle',
  },
};
